import { useState } from 'react'
import { sentimentDirection, directionArrow } from '../../utils/snapshots.js'

// SentimentTrend — collapsible sparkline below bill vote bars.
// Props:
//   - snapshots:   array of snapshot objects from loadSnapshots()
//   - billActions: array of {action_date, action_text} for annotation labels
export default function SentimentTrend({ snapshots, billActions = [] }) {
  const [expanded, setExpanded] = useState(false)

  if (!snapshots || snapshots.length < 2) return null

  const direction = sentimentDirection(snapshots)
  const arrow = directionArrow(direction)
  const directionColor = ({
    rising: 'var(--yes-text)',
    falling: 'var(--no-text)',
    stable: 'var(--unsure-text)',
    insufficient: 'var(--unsure-text)',
  })[direction]

  const chartHeight = 48

  return (
    <div className="sentiment-trend">
      <div
        className="sentiment-trend-toggle"
        onClick={() => setExpanded(!expanded)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setExpanded(!expanded) }}
      >
        <span className="sentiment-trend-label">
          Sentiment trend{' '}
          <span style={{ color: directionColor, fontWeight: 500 }}>
            {arrow}{direction !== 'insufficient' ? ` ${direction}` : ''}
          </span>
        </span>
        <span className="sentiment-trend-chevron">
          {expanded ? 'Hide ↑' : 'Show ↓'}
        </span>
      </div>

      {expanded && (
        <div className="sentiment-trend-body">
          <svg
            width="100%"
            height={chartHeight + 16}
            viewBox={`0 0 ${snapshots.length * 24} ${chartHeight + 16}`}
          >
            {snapshots.map((s, i) => {
              const x = i * 24 + 12
              const barH = Math.max(2, Math.round((s.yes_pct / 100) * chartHeight))
              const y = chartHeight - barH
              const next = snapshots[i + 1]
              return (
                <g key={i}>
                  <rect x={x - 5} y={y} width={10} height={barH}
                        fill="var(--yes-bar)" opacity={0.8} rx={2} />
                  {next && (
                    <line
                      x1={x}
                      y1={chartHeight - Math.round((s.yes_pct / 100) * chartHeight)}
                      x2={x + 24}
                      y2={chartHeight - Math.round((next.yes_pct / 100) * chartHeight)}
                      stroke="var(--yes-bar)"
                      strokeWidth={1}
                      opacity={0.4}
                    />
                  )}
                  <text x={x} y={chartHeight + 12} textAnchor="middle"
                        fontSize={8} fill="var(--stone)">
                    {new Date(s.snapshot_at).toLocaleDateString('en-US', {
                      month: 'numeric', day: 'numeric',
                    })}
                  </text>
                </g>
              )
            })}
          </svg>

          {billActions.length > 0 && (
            <div className="sentiment-trend-actions">
              {billActions.slice(-3).map((a, i) => (
                <div key={i} className="sentiment-trend-action">
                  <span className="action-date">
                    {new Date(a.action_date).toLocaleDateString('en-US', {
                      month: 'short', day: 'numeric',
                    })}
                  </span>
                  <span>{a.action_text}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
